import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "account-list"
};
const _hoisted_2 = {
    key: 11,
    class: "empty-state"
};
const _hoisted_3 = { class: "empty-state-text" };
const _hoisted_4 = { class: "empty-state-subtext" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 0,
    class: "account-cards-grid"
};
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "account-cards-grid" };
const _hoisted_9 = { class: "account-cards-grid" };
const _hoisted_10 = { class: "account-cards-grid" };
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import AccountCard from './AccountCard.vue';
import AccountListItem from './AccountListItem.vue';
import MGButton from './MGButton.vue';
import SectionHeader from './SectionHeader.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountCardsSection',
    props: {
        currentAccounts: { default: () => [] },
        currentAccountsBalance: { default: 0 },
        creditAccounts: { default: () => [] },
        creditAccountsBalance: { default: 0 },
        savingAccounts: { default: () => [] },
        savingAccountsBalance: { default: 0 },
        mortgageInfo: { default: () => [] },
        insuranceInfo: { default: () => [] },
        creditInfo: { default: () => [] },
        investmentInfo: { default: () => [] },
        showCurrentCard: { type: Boolean, default: false },
        showCreditCard: { type: Boolean, default: false },
        showSavingCard: { type: Boolean, default: false },
        showMortgageCard: { type: Boolean, default: false },
        showPensionCard: { type: Boolean, default: false },
        showInvestmentCard: { type: Boolean, default: false },
        showInsuranceCard: { type: Boolean, default: false },
        showCreditInfo: { type: Boolean, default: false },
        formatter: {},
        selectedSection: { default: 'all' },
        selectedSubSection: { default: 'all' },
        suggestedAssets: { default: () => [] }
    },
    emits: ["add-account-click", "filter-changed", "suggested-asset-click"],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const emit = __emit;
        const props = __props;
        function cleanBrandName(name) {
            if (!name)
                return '';
            const map = { 'ø': 'o', 'Ø': 'O', 'æ': 'ae', 'Æ': 'AE', 'ß': 'ss', 'ð': 'd', 'Ð': 'D', 'þ': 'th', 'Þ': 'Th', 'đ': 'd', 'Đ': 'D', 'ł': 'l', 'Ł': 'L' };
            let ret = name.replace(/[ /]/g, '+');
            ret = ret.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\x7E]/g, function (c) { return map[c] || ''; });
            ret = encodeURIComponent(ret);
            return ret;
        }
        function getBrandLogoUrl(name) {
            if (!name)
                return require('@/assets/round3.png');
            return 'https://api.sysodev.link/BrandLogos/' + cleanBrandName(name);
        }
        function processMonetaryAmounts(text) {
            if (localStorage.getItem('randomiseFigures') !== 'true')
                return text;
            const monetaryPattern = /(?:£|$)(?:\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)|(?:\d+(?:\.\d{2})?\s*(?:pounds?|pence|p|GBP|USD))/gi;
            return text.replace(monetaryPattern, () => '£####');
        }
        const pensionAccounts = computed(() => {
            if (!props.investmentInfo)
                return [];
            return props.investmentInfo.filter((account) => account.accountType?.name === 'Pension');
        });
        const investmentAccounts = computed(() => {
            if (!props.investmentInfo)
                return [];
            return props.investmentInfo.filter((account) => account.accountType?.name === 'Investment');
        });
        const totalVisibleCards = computed(() => {
            let count = 0;
            if (props.currentAccounts.length > 0 && props.showCurrentCard)
                count++;
            if (props.creditAccounts.length > 0 && props.showCreditCard)
                count++;
            if (props.insuranceInfo && props.insuranceInfo.length > 0 && props.showInsuranceCard)
                count++;
            if (props.mortgageInfo && props.mortgageInfo.length > 0 && props.showMortgageCard)
                count++;
            if (props.savingAccounts.length > 0 && props.showSavingCard)
                count++;
            if (props.creditInfo && props.creditInfo.length > 0 && props.showCreditInfo)
                count++;
            if (pensionAccounts.value && pensionAccounts.value.length > 0 && props.showPensionCard)
                count++;
            return count;
        });
        const showSectionHeaders = computed(() => totalVisibleCards.value >= 5);
        const isFilterActive = computed(() => props.selectedSection !== 'all');
        const mortgageBalance = computed(() => {
            if (!props.mortgageInfo || props.mortgageInfo.length === 0)
                return 0;
            return props.mortgageInfo.reduce((sum, m) => sum + (m.account?.balance?.amount || 0), 0);
        });
        const loanBalance = computed(() => {
            if (!props.creditInfo || props.creditInfo.length === 0)
                return 0;
            return props.creditInfo.reduce((sum, l) => sum + (l.balance?.amount || 0), 0);
        });
        const pensionBalance = computed(() => {
            if (!pensionAccounts.value || pensionAccounts.value.length === 0)
                return 0;
            return pensionAccounts.value.reduce((sum, a) => sum + (a.balance || 0), 0);
        });
        const investmentBalance = computed(() => {
            if (!investmentAccounts.value || investmentAccounts.value.length === 0)
                return 0;
            return investmentAccounts.value.reduce((sum, a) => sum + (a.balance || 0), 0);
        });
        const insuranceBalance = computed(() => {
            if (!props.insuranceInfo || props.insuranceInfo.length === 0)
                return 0;
            return props.insuranceInfo.reduce((sum, p) => {
                const itemsSum = (p.insuredItems || []).reduce((is, i) => is + (i.valueInsured || 0), 0);
                return sum + itemsSum;
            }, 0);
        });
        const suggestedInsuranceAssets = computed(() => {
            if (!props.suggestedAssets)
                return [];
            return props.suggestedAssets.filter((a) => {
                const s = a.uiElement?.section || '';
                return s === 'Insurance' || s.startsWith('Insurance >');
            });
        });
        const suggestedLongTermAssets = computed(() => {
            if (!props.suggestedAssets)
                return [];
            const subMap = { 'mortgages': 'Mortgages', 'loans': 'Loans', 'pensions': 'Pensions', 'investments': 'Investments' };
            return props.suggestedAssets.filter((a) => {
                const s = a.uiElement?.section || '';
                if (s !== 'Long-term' && !s.startsWith('Long-term >'))
                    return false;
                if (props.selectedSubSection === 'all')
                    return true;
                const subCategory = s.split('> ')[1]?.trim();
                return subCategory === subMap[props.selectedSubSection];
            });
        });
        const suggestedDayToDayAssets = computed(() => {
            if (!props.suggestedAssets)
                return [];
            return props.suggestedAssets.filter((a) => {
                const s = a.uiElement?.section || '';
                return s === 'Day-to-day' || s.startsWith('Day-to-day >');
            });
        });
        const isDayToDayEmpty = computed(() => props.currentAccounts.length === 0 && props.creditAccounts.length === 0 && props.savingAccounts.length === 0 && suggestedDayToDayAssets.value.length === 0);
        const isLongTermEmpty = computed(() => (!props.mortgageInfo || props.mortgageInfo.length === 0) && (!props.creditInfo || props.creditInfo.length === 0) && (!pensionAccounts.value || pensionAccounts.value.length === 0) && (!investmentAccounts.value || investmentAccounts.value.length === 0) && suggestedLongTermAssets.value.length === 0);
        const isInsuranceEmpty = computed(() => (!props.insuranceInfo || props.insuranceInfo.length === 0) && suggestedInsuranceAssets.value.length === 0);
        const isCurrentSubSectionEmpty = computed(() => {
            if (props.selectedSubSection === 'all')
                return false;
            const subSectionMap = {
                'current': 'Day-to-day > Current', 'credit': 'Day-to-day > Credit', 'savings': 'Day-to-day > Savings',
                'mortgages': 'Long-term > Mortgages', 'pensions': 'Long-term > Pensions', 'investments': 'Long-term > Investments', 'loans': 'Long-term > Loans'
            };
            const hasSugg = hasSuggestedForSection(subSectionMap[props.selectedSubSection]);
            if (props.selectedSubSection === 'current')
                return props.currentAccounts.length === 0 && !hasSugg;
            if (props.selectedSubSection === 'credit')
                return props.creditAccounts.length === 0 && !hasSugg;
            if (props.selectedSubSection === 'savings')
                return props.savingAccounts.length === 0 && !hasSugg;
            if (props.selectedSubSection === 'mortgages')
                return (!props.mortgageInfo || props.mortgageInfo.length === 0) && !hasSugg;
            if (props.selectedSubSection === 'pensions')
                return (!pensionAccounts.value || pensionAccounts.value.length === 0) && !hasSugg;
            if (props.selectedSubSection === 'investments')
                return (!investmentAccounts.value || investmentAccounts.value.length === 0) && !hasSugg;
            if (props.selectedSubSection === 'loans')
                return (!props.creditInfo || props.creditInfo.length === 0) && !hasSugg;
            return false;
        });
        const showEmptyState = computed(() => {
            if (isCurrentSubSectionEmpty.value)
                return true;
            return (props.selectedSection === 'd2d' && isDayToDayEmpty.value) || (props.selectedSection === 'lt' && isLongTermEmpty.value) || (props.selectedSection === 'ins' && isInsuranceEmpty.value);
        });
        const emptyStateHeadline = computed(() => {
            if (props.selectedSection === 'd2d')
                return 'Track your everyday spending';
            if (props.selectedSection === 'lt')
                return 'See your long-term money clearly';
            if (props.selectedSection === 'ins')
                return 'Keep on top of your cover';
            return '';
        });
        const emptyStateSubtext = computed(() => {
            if (props.selectedSection === 'd2d')
                return "Work out where your money's going – and where you want it to go instead.";
            if (props.selectedSection === 'lt')
                return "Get a better view of your future finances – what's growing and where you're headed.";
            if (props.selectedSection === 'ins')
                return "Store your policies here and we'll remind you before anything's up for renewal.";
            return '';
        });
        const emptyStateButtonText = computed(() => {
            if (props.selectedSubSection === 'current')
                return 'Add current account';
            if (props.selectedSubSection === 'credit')
                return 'Add credit card';
            if (props.selectedSubSection === 'savings')
                return 'Add savings account';
            if (props.selectedSubSection === 'mortgages')
                return 'Add mortgage';
            if (props.selectedSubSection === 'pensions')
                return 'Add pension';
            if (props.selectedSubSection === 'investments')
                return 'Add investment';
            if (props.selectedSubSection === 'loans')
                return 'Add loan';
            if (props.selectedSection === 'd2d')
                return 'Add day-to-day account';
            if (props.selectedSection === 'lt')
                return 'Add long term account';
            if (props.selectedSection === 'ins')
                return 'Add insurance';
            return '';
        });
        function properCase(str) {
            if (!str)
                return '';
            return str.replace(/\b\w/g, (c) => c.toUpperCase());
        }
        function getBrandLogo(name) {
            if (!name)
                return require('@/assets/round1.png');
            return getBrandLogoUrl(name);
        }
        function hasSuggestedForSection(prefix) {
            if (!prefix || !props.suggestedAssets)
                return false;
            return props.suggestedAssets.some((a) => {
                const s = a.uiElement?.section || '';
                return s === prefix || s.startsWith(prefix + ' >');
            });
        }
        function getCurrentAccountsBalance() { return props.formatter.format(props.currentAccountsBalance); }
        function getCreditCardsBalance() { return props.formatter.format(props.creditAccountsBalance); }
        function getSavingAccountsBalance() { return props.formatter.format(props.savingAccountsBalance); }
        function getCurrentAccountIcon() { return require('@/assets/accountTypes/current-account.png'); }
        function getCreditCardIcon() { return require('@/assets/accountTypes/credit-card.png'); }
        function getMortgageIcon() { return require('@/assets/accountTypes/mortgage.png'); }
        function getInsuranceIcon() { return require('@/assets/accountTypes/insurance.png'); }
        function getCreditInfoIcon() { return require('@/assets/accountTypes/loans.png'); }
        function getSavingsAccountIcon() { return require('@/assets/accountTypes/savings-account.png'); }
        function getAccountIcons(items, config) {
            const icons = [];
            if (items && items.length > 0) {
                items.forEach((item) => {
                    const providerPath = config.providerPath.split('.');
                    let provider = item;
                    for (const key of providerPath) {
                        provider = provider?.[key];
                    }
                    if (provider) {
                        let iconUrl = provider.logoUri;
                        if (!iconUrl && provider.name) {
                            iconUrl = getBrandLogoUrl(provider.name);
                        }
                        if (!iconUrl) {
                            iconUrl = require('@/assets/round1.png');
                        }
                        if (iconUrl) {
                            icons.push(iconUrl);
                        }
                    }
                });
            }
            return icons;
        }
        function getSuggestedIconsForSection(sectionMatch) {
            if (!props.suggestedAssets)
                return [];
            return props.suggestedAssets
                .filter((a) => { const s = a.uiElement?.section || ''; return s === sectionMatch || s.startsWith(sectionMatch + ' >'); })
                .map((a) => getBrandLogo(a.provider));
        }
        function getAllCreditCardIcons() { return [...getAccountIcons(props.creditAccounts, { providerPath: 'bank' }), ...getSuggestedIconsForSection('Day-to-day > Credit')]; }
        function getAllPensionAccountIcons() { return [...getAccountIcons(pensionAccounts.value, { providerPath: 'provider' }), ...getSuggestedIconsForSection('Long-term > Pensions')]; }
        function getAllInvestmentAccountIcons() { return [...getAccountIcons(investmentAccounts.value, { providerPath: 'provider' }), ...getSuggestedIconsForSection('Long-term > Investments')]; }
        function getAllSavingsAccountIcons() { return [...getAccountIcons(props.savingAccounts, { providerPath: 'bank' }), ...getSuggestedIconsForSection('Day-to-day > Savings')]; }
        function getAllCurrentAccountIcons() { return [...getAccountIcons(props.currentAccounts, { providerPath: 'bank' }), ...getSuggestedIconsForSection('Day-to-day > Current')]; }
        function getAllMortgageAccountIcons() { return [...getAccountIcons(props.mortgageInfo, { providerPath: 'account.provider' }), ...getSuggestedIconsForSection('Long-term > Mortgages')]; }
        function getAllInsuranceAccountIcons() { return [...getAccountIcons(props.insuranceInfo, { providerPath: 'provider' }), ...getSuggestedIconsForSection('Insurance')]; }
        function getAllCreditInfoIcons() { return [...getAccountIcons(props.creditInfo, { providerPath: 'provider' }), ...getSuggestedIconsForSection('Long-term > Loans')]; }
        function handleCurrentAccountClick() { emit('filter-changed', { section: 'd2d', subSection: 'current' }); }
        function handleCreditAccountClick() { emit('filter-changed', { section: 'd2d', subSection: 'credit' }); }
        function handleSavingAccountClick() { emit('filter-changed', { section: 'd2d', subSection: 'savings' }); }
        function handleMortgageClick() { emit('filter-changed', { section: 'lt', subSection: 'mortgages' }); }
        function handleCreditClick() { emit('filter-changed', { section: 'lt', subSection: 'loans' }); }
        function handleInsuranceClick() { emit('filter-changed', { section: 'ins' }); }
        function handlePensionClick() { emit('filter-changed', { section: 'lt', subSection: 'pensions' }); }
        function handleInvestmentClick() { emit('filter-changed', { section: 'lt', subSection: 'investments' }); }
        function navigateToDayToDay() { router.push('/money'); }
        function navigateToLongTerm() { router.push('/money'); }
        function navigateToInsurance() { router.push('/money'); }
        function handleSpendingAnalysisClick() { router.push('/SpendingAnalysis'); }
        function handleAddAccountClick() {
            if (props.selectedSection === 'ins') {
                router.push('/Policies/Insurance/Add');
                return;
            }
            const subSections = ['current', 'credit', 'savings', 'mortgages', 'loans', 'pensions', 'investments'];
            if (subSections.includes(props.selectedSubSection)) {
                emit('add-account-click', props.selectedSubSection);
                return;
            }
            emit('add-account-click', props.selectedSection);
        }
        function handleAccountListItemClick(account, type) {
            if (type === 'mortgage')
                router.push(`/Mortgages/${account.id}`);
            else if (type === 'policy')
                router.push(`/Policies/${account.id}`);
            else if (type === 'pension')
                router.push(`/Pensions/${account.id}`);
            else if (type === 'investment')
                router.push(`/Investments/${account.id}`);
            else if (type === 'loan')
                router.push(`/Credit/${account.id}`);
            else
                router.push(`/Account/${account.id}`);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (isFilterActive.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_ctx.showCurrentCard && _ctx.currentAccounts.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Current accounts",
                                        rightLabel: getCurrentAccountsBalance(),
                                        class: "section-header"
                                    }, null, 8, ["rightLabel"]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentAccounts, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `current-${account.id}`,
                                        "provider-name": account.bank?.name || 'Bank',
                                        line1: account.accountType?.prettyName || 'Current',
                                        line2: account.accountNumber || '',
                                        value: _ctx.formatter.format(account.balance),
                                        label: "Balance",
                                        "avatar-url": account.bank?.logoUri || getBrandLogo(account.bank?.name),
                                        "badge-url": account.source === 0 ? require('@/assets/openbankingmarker.png') : null,
                                        onClick: ($event) => (handleAccountListItemClick(account, 'current'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "badge-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showCreditCard && _ctx.creditAccounts.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Credit Cards",
                                        rightLabel: getCreditCardsBalance(),
                                        class: "section-header"
                                    }, null, 8, ["rightLabel"]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditAccounts, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `credit-${account.id}`,
                                        "provider-name": account.bank?.name || 'Bank',
                                        line1: account.accountType?.prettyName || 'Credit',
                                        line2: account.accountNumber || '',
                                        value: _ctx.formatter.format(account.balance),
                                        label: "Balance",
                                        "avatar-url": account.bank?.logoUri || getBrandLogo(account.bank?.name),
                                        "badge-url": account.source === 0 ? require('@/assets/openbankingmarker.png') : null,
                                        onClick: ($event) => (handleAccountListItemClick(account, 'credit'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "badge-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showSavingCard && _ctx.savingAccounts.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Savings accounts",
                                        rightLabel: getSavingAccountsBalance(),
                                        class: "section-header"
                                    }, null, 8, ["rightLabel"]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savingAccounts, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `savings-${account.id}`,
                                        "provider-name": account.bank?.name || 'Bank',
                                        line1: account.accountType?.prettyName || 'Savings',
                                        line2: account.accountNumber || '',
                                        value: _ctx.formatter.format(account.balance),
                                        label: "Balance",
                                        "avatar-url": account.bank?.logoUri || getBrandLogo(account.bank?.name),
                                        "badge-url": account.source === 0 ? require('@/assets/openbankingmarker.png') : null,
                                        onClick: ($event) => (handleAccountListItemClick(account, 'savings'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "badge-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showMortgageCard && _ctx.mortgageInfo && _ctx.mortgageInfo.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Mortgages",
                                        class: "section-header"
                                    }))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mortgageInfo, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `mortgage-${account.id}`,
                                        "provider-name": account.account?.provider?.name || 'Provider',
                                        line1: account.policyType?.name || 'Mortgage',
                                        line2: account.account?.reference || '',
                                        value: _ctx.formatter.format(account.account?.balance?.amount || 0),
                                        label: "Balance",
                                        "avatar-url": getBrandLogo(account.account?.provider?.name),
                                        onClick: ($event) => (handleAccountListItemClick(account, 'mortgage'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showCreditInfo && _ctx.creditInfo && _ctx.creditInfo.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Loans",
                                        class: "section-header"
                                    }))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditInfo, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `loan-${account.id}`,
                                        "provider-name": account.provider?.name || 'Provider',
                                        line1: account.creditType?.name || 'Loan',
                                        line2: account.reference || '',
                                        value: _ctx.formatter.format(account.balance?.amount || 0),
                                        label: "Balance",
                                        "avatar-url": getBrandLogo(account.provider?.name),
                                        onClick: ($event) => (handleAccountListItemClick(account, 'loan'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showPensionCard && pensionAccounts.value && pensionAccounts.value.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Pensions",
                                        class: "section-header"
                                    }))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pensionAccounts.value, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `pension-${account.id}`,
                                        "provider-name": account.provider?.name || 'Provider',
                                        line1: account.investmentType?.name || 'Pension',
                                        line2: account.reference || '',
                                        value: typeof account.balance === 'number' ? _ctx.formatter.format(account.balance) : _ctx.formatter.format(0),
                                        label: "Balance",
                                        "avatar-url": getBrandLogo(account.provider?.name),
                                        onClick: ($event) => (handleAccountListItemClick(account, 'pension'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showInvestmentCard && investmentAccounts.value && investmentAccounts.value.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Investments",
                                        class: "section-header"
                                    }))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(investmentAccounts.value, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `investment-${account.id}`,
                                        "provider-name": account.provider?.name || 'Provider',
                                        line1: account.investmentType?.name || 'Investment',
                                        line2: account.reference || '',
                                        value: typeof account.balance === 'number' ? _ctx.formatter.format(account.balance) : _ctx.formatter.format(0),
                                        label: "Balance",
                                        "avatar-url": getBrandLogo(account.provider?.name),
                                        onClick: ($event) => (handleAccountListItemClick(account, 'investment'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.showInsuranceCard && _ctx.insuranceInfo && _ctx.insuranceInfo.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                (_ctx.selectedSubSection !== 'all')
                                    ? (_openBlock(), _createBlock(SectionHeader, {
                                        key: 0,
                                        title: "Insurance Policies",
                                        class: "section-header"
                                    }))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insuranceInfo, (account) => {
                                    return (_openBlock(), _createBlock(AccountListItem, {
                                        key: `insurance-${account.id}`,
                                        "provider-name": account.provider?.name || 'Provider',
                                        line1: account.policyType?.name || 'Insurance',
                                        line2: account.policyNumber || '',
                                        value: account.endDateString,
                                        label: "Renewal",
                                        "avatar-url": getBrandLogo(account.provider?.name),
                                        onClick: ($event) => (handleAccountListItemClick(account, 'policy'))
                                    }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url", "onClick"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true),
                        ((_ctx.selectedSection === 'all' || _ctx.selectedSection === 'ins'))
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 8,
                                name: "fade"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedInsuranceAssets.value, (asset, index) => {
                                        return (_openBlock(), _createBlock(AccountListItem, {
                                            key: `suggested-ins-${index}`,
                                            "provider-name": properCase(asset.uiElement.title),
                                            line1: asset.uiElement.subTitle,
                                            line2: "",
                                            label: asset.uiElement.rightTopValue ? asset.uiElement.rightTopLabel : '',
                                            value: processMonetaryAmounts(asset.uiElement.rightTopValue || ''),
                                            label2: asset.uiElement.rightBottomValue ? asset.uiElement.rightBottomLabel : '',
                                            value2: processMonetaryAmounts(asset.uiElement.rightBottomValue || ''),
                                            "avatar-url": getBrandLogo(asset.provider),
                                            "badge-url": require('@/assets/aisummary.png'),
                                            onClick: ($event) => (emit('suggested-asset-click', asset))
                                        }, null, 8, ["provider-name", "line1", "label", "value", "label2", "value2", "avatar-url", "badge-url", "onClick"]));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        ((_ctx.selectedSection === 'all' || _ctx.selectedSection === 'lt'))
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 9,
                                name: "fade"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedLongTermAssets.value, (asset, index) => {
                                        return (_openBlock(), _createBlock(AccountListItem, {
                                            key: `suggested-lt-${index}`,
                                            "provider-name": properCase(asset.uiElement.title),
                                            line1: asset.uiElement.subTitle,
                                            line2: "",
                                            label: asset.uiElement.rightTopValue ? asset.uiElement.rightTopLabel : '',
                                            value: processMonetaryAmounts(asset.uiElement.rightTopValue || ''),
                                            label2: asset.uiElement.rightBottomValue ? asset.uiElement.rightBottomLabel : '',
                                            value2: processMonetaryAmounts(asset.uiElement.rightBottomValue || ''),
                                            "avatar-url": getBrandLogo(asset.provider),
                                            "badge-url": require('@/assets/aisummary.png'),
                                            onClick: ($event) => (emit('suggested-asset-click', asset))
                                        }, null, 8, ["provider-name", "line1", "label", "value", "label2", "value2", "avatar-url", "badge-url", "onClick"]));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        ((_ctx.selectedSection === 'all' || _ctx.selectedSection === 'd2d'))
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 10,
                                name: "fade"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedDayToDayAssets.value, (asset, index) => {
                                        return (_openBlock(), _createBlock(AccountListItem, {
                                            key: `suggested-d2d-${index}`,
                                            "provider-name": properCase(asset.uiElement.title),
                                            line1: asset.uiElement.subTitle,
                                            line2: "",
                                            label: asset.uiElement.rightTopValue ? asset.uiElement.rightTopLabel : '',
                                            value: processMonetaryAmounts(asset.uiElement.rightTopValue || ''),
                                            label2: asset.uiElement.rightBottomValue ? asset.uiElement.rightBottomLabel : '',
                                            value2: processMonetaryAmounts(asset.uiElement.rightBottomValue || ''),
                                            "avatar-url": getBrandLogo(asset.provider),
                                            "badge-url": require('@/assets/aisummary.png'),
                                            onClick: ($event) => (emit('suggested-asset-click', asset))
                                        }, null, 8, ["provider-name", "line1", "label", "value", "label2", "value2", "avatar-url", "badge-url", "onClick"]));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (showEmptyState.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("p", _hoisted_3, _toDisplayString(emptyStateHeadline.value), 1),
                                _createElementVNode("p", _hoisted_4, _toDisplayString(emptyStateSubtext.value), 1),
                                _createVNode(MGButton, {
                                    fullWidth: true,
                                    noCaps: true,
                                    stacked: true,
                                    closerStack: true,
                                    text: emptyStateButtonText.value,
                                    plus: true,
                                    onClick: handleAddAccountClick
                                }, null, 8, ["text"])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.selectedSection === 'd2d' && _ctx.currentAccounts.length > 0 && !showEmptyState.value)
                            ? (_openBlock(), _createBlock(MGButton, {
                                key: 12,
                                fullWidth: true,
                                noCaps: true,
                                text: "See spending analysis",
                                outline: true,
                                arrow: true,
                                onClick: handleSpendingAnalysisClick,
                                icon: require('@/assets/spending-analysis.png'),
                                leftIconSize: "16"
                            }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                        ((_ctx.selectedSection === 'd2d' || _ctx.selectedSection === 'lt' || _ctx.selectedSection === 'ins') && !showEmptyState.value)
                            ? (_openBlock(), _createBlock(MGButton, {
                                key: 13,
                                class: "add-account-button",
                                fullWidth: true,
                                noCaps: true,
                                stacked: true,
                                closerStack: true,
                                text: emptyStateButtonText.value,
                                plus: true,
                                onClick: handleAddAccountClick
                            }, null, 8, ["text"]))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (!showSectionHeaders.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_ctx.currentAccounts.length > 0 && _ctx.showCurrentCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "current-account",
                                        label: "Current",
                                        icon: getCurrentAccountIcon(),
                                        accountIcons: getAllCurrentAccountIcons(),
                                        balance: _ctx.formatter.format(_ctx.currentAccountsBalance),
                                        onClick: handleCurrentAccountClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (_ctx.creditAccounts.length > 0 && _ctx.showCreditCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "credit-account",
                                        label: "Credit Card",
                                        icon: getCreditCardIcon(),
                                        accountIcons: getAllCreditCardIcons(),
                                        balance: _ctx.formatter.format(_ctx.creditAccountsBalance),
                                        onClick: handleCreditAccountClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (_ctx.savingAccounts.length > 0 && _ctx.showSavingCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "savings-account",
                                        label: "Savings",
                                        icon: getSavingsAccountIcon(),
                                        accountIcons: getAllSavingsAccountIcons(),
                                        balance: _ctx.formatter.format(_ctx.savingAccountsBalance),
                                        onClick: handleSavingAccountClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (_ctx.mortgageInfo && _ctx.mortgageInfo.length > 0 && _ctx.showMortgageCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "mortgage",
                                        label: "Mortgage",
                                        icon: getMortgageIcon(),
                                        accountIcons: getAllMortgageAccountIcons(),
                                        balance: _ctx.formatter.format(mortgageBalance.value),
                                        onClick: handleMortgageClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (_ctx.insuranceInfo && _ctx.insuranceInfo.length > 0 && _ctx.showInsuranceCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "insurance",
                                        label: "Insurance Policies",
                                        icon: getInsuranceIcon(),
                                        accountIcons: getAllInsuranceAccountIcons(),
                                        "b-alance": _ctx.formatter.format(insuranceBalance.value),
                                        onClick: handleInsuranceClick
                                    }, null, 8, ["icon", "accountIcons", "b-alance"]))
                                    : _createCommentVNode("", true),
                                (_ctx.creditInfo && _ctx.creditInfo.length > 0 && _ctx.showCreditInfo)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "credit",
                                        label: "Loans",
                                        icon: getCreditInfoIcon(),
                                        accountIcons: getAllCreditInfoIcons(),
                                        balance: _ctx.formatter.format(loanBalance.value),
                                        onClick: handleCreditClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (pensionAccounts.value && pensionAccounts.value.length > 0 && _ctx.showPensionCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "pension",
                                        label: "Pension",
                                        icon: require('@/assets/accountTypes/pension.png'),
                                        accountIcons: getAllPensionAccountIcons(),
                                        balance: _ctx.formatter.format(pensionBalance.value),
                                        onClick: handlePensionClick
                                    }, null, 8, ["icon", "accountIcons", "balance"]))
                                    : _createCommentVNode("", true),
                                (investmentAccounts.value && investmentAccounts.value.length > 0 && _ctx.showInvestmentCard)
                                    ? (_openBlock(), _createBlock(AccountCard, {
                                        key: "investment",
                                        label: "Investments",
                                        balance: _ctx.formatter.format(investmentBalance.value),
                                        icon: require('@/assets/accountTypes/investments.png'),
                                        accountIcons: getAllInvestmentAccountIcons(),
                                        onClick: handleInvestmentClick
                                    }, null, 8, ["balance", "icon", "accountIcons"]))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                ((_ctx.currentAccounts.length > 0 && _ctx.showCurrentCard) || (_ctx.creditAccounts.length > 0 && _ctx.showCreditCard))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(SectionHeader, {
                                            title: "Day-to-day",
                                            class: "section-header",
                                            onAction: navigateToDayToDay
                                        }),
                                        _createElementVNode("div", _hoisted_8, [
                                            (_ctx.currentAccounts.length > 0 && _ctx.showCurrentCard)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "current-account",
                                                    label: "Current accounts",
                                                    icon: getCurrentAccountIcon(),
                                                    accountIcons: getAllCurrentAccountIcons(),
                                                    balance: _ctx.formatter.format(_ctx.currentAccountsBalance),
                                                    onClick: handleCurrentAccountClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true),
                                            (_ctx.creditAccounts.length > 0 && _ctx.showCreditCard)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "credit-account",
                                                    label: "Credit cards",
                                                    icon: getCreditCardIcon(),
                                                    accountIcons: getAllCreditCardIcons(),
                                                    balance: _ctx.formatter.format(_ctx.creditAccountsBalance),
                                                    onClick: handleCreditAccountClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true),
                                            (_ctx.savingAccounts.length > 0 && _ctx.showSavingCard)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "savings-account",
                                                    label: "Savings",
                                                    icon: getSavingsAccountIcon(),
                                                    accountIcons: getAllSavingsAccountIcons(),
                                                    balance: _ctx.formatter.format(_ctx.savingAccountsBalance),
                                                    onClick: handleSavingAccountClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                (_ctx.mortgageInfo && _ctx.mortgageInfo.length > 0 && _ctx.showMortgageCard)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createVNode(SectionHeader, {
                                            title: "Long-term",
                                            class: "section-header",
                                            onAction: navigateToLongTerm
                                        }),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode(AccountCard, {
                                                key: "mortgage",
                                                label: "Mortgages",
                                                icon: getMortgageIcon(),
                                                accountIcons: getAllMortgageAccountIcons(),
                                                balance: _ctx.formatter.format(mortgageBalance.value),
                                                onClick: handleMortgageClick
                                            }, null, 8, ["icon", "accountIcons", "balance"]),
                                            (_ctx.creditInfo && _ctx.creditInfo.length > 0 && _ctx.showCreditInfo)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "credit",
                                                    label: "Loans",
                                                    icon: getCreditInfoIcon(),
                                                    accountIcons: getAllCreditInfoIcons(),
                                                    balance: _ctx.formatter.format(loanBalance.value),
                                                    onClick: handleCreditClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true),
                                            (pensionAccounts.value && pensionAccounts.value.length > 0 && _ctx.showPensionCard)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "pension",
                                                    label: "Pensions",
                                                    icon: require('@/assets/accountTypes/pension.png'),
                                                    accountIcons: getAllPensionAccountIcons(),
                                                    balance: _ctx.formatter.format(pensionBalance.value),
                                                    onClick: handlePensionClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true),
                                            (investmentAccounts.value && investmentAccounts.value.length > 0 && _ctx.showInvestmentCard)
                                                ? (_openBlock(), _createBlock(AccountCard, {
                                                    key: "investment",
                                                    label: "Investments",
                                                    icon: require('@/assets/accountTypes/investments.png'),
                                                    accountIcons: getAllInvestmentAccountIcons(),
                                                    balance: _ctx.formatter.format(investmentBalance.value),
                                                    onClick: handleInvestmentClick
                                                }, null, 8, ["icon", "accountIcons", "balance"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                (_ctx.insuranceInfo && _ctx.insuranceInfo.length > 0 && _ctx.showInsuranceCard)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createVNode(SectionHeader, {
                                            title: "Insurance",
                                            class: "section-header",
                                            onAction: navigateToInsurance
                                        }),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(AccountCard, {
                                                key: "insurance",
                                                label: "Insurance Policies",
                                                icon: getInsuranceIcon(),
                                                accountIcons: getAllInsuranceAccountIcons(),
                                                "b-alance": _ctx.formatter.format(insuranceBalance.value),
                                                onClick: handleInsuranceClick
                                            }, null, 8, ["icon", "accountIcons", "b-alance"])
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ]))
                    ]))
            ]));
        };
    }
});
